import React, { Component } from "react";
import {
  RouterProps,
  Styled
} from "../../../../../toolkit/decorators/Artifact";
import { Container } from "reactstrap";
import FormBuilder from "../../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfig } from "./BAsignacion.form";
import { MemoTable } from "./BAsignacion.table";
import DeportivaEventoAsignable from "../../../../../types/DeportivaEventoAsignable";
import { deleteEmptyProps } from "../../../../../toolkit/utils/filter-utils";
import {
  errorNotification,
  successNotification
} from "../../../../../utils/notifications";
import s from "../../styles.scss";
import ITypeSelectBuilder from "../../../../../toolkit/baseForms2/iTypeSelectBuilder/ITypeSelectBuilder";
import FormBuilderModal from "../../../common/formBuilderModal/formBuilderModal";
import { BAsignacionDispatcher } from "../../../../containers/comisionesDeportivaV2Carrusel/steps/BAsignacion.dispatcher";
import { BAsignacionStore } from "../../../../containers/comisionesDeportivaV2Carrusel/steps/BAsignacion.store";
import { formConfigClase } from "./BAsignacionClase.form";
import { formConfigPrograma } from "./BAsignacionPrograma.form";
import { caducidadFormConfig } from "./BAsignacionCaducidad.form";
import PersonSelector from "../../../../../People/containers/PersonSelector";
import { Person } from "../../../oneDayPassActivatorPage/interfaces";
import {
  Archivo,
  ArchivoHistorico,
  ArchivoId,
  RequestArchivo,
  StatusAutorizacion
} from "../../../expedientsV2controls/types";
import { Preview } from "../../../../../types/IAction";
import { BAsignacionArchivosPopUp } from "./BAsignacionArchivos.popup";
import permissionCodes from "../../../../../utils/permissionCodes";
import { userHasPermission } from "../../../../../utils/accessTree";

const {
  COMISIONES_V2_ASIGNAR_EVENTO_RECUPERAR_DOCUMENTO: RECUPERAR_DOCUMENTO
} = permissionCodes;

interface Props extends BAsignacionDispatcher, BAsignacionStore, RouterProps {}

interface State {
  downloading: boolean;
  idCliente: string;
  tipoBusqueda: string;
  filters: Inputs & {
    page: number;
    size: number;
  };

  // Actualización de empleado
  rowPopup: DeportivaEventoAsignable;
  clasePopupOpen: boolean;
  clasePopupTitle: string;
  clasePopupText: string;
  programaPopupOpen: boolean;
  programaPopupTitle: string;
  programaPopupText: string;

  // Configuración de caducidad
  caducidadPopupOpen: boolean;
  caducidadPopupTitle: string;
  caducidadPopupText: string;

  // Confirmación de acciones en documentos
  archivoPopup: Archivo;
  documentoPopupOpen: boolean;
  documentoPopupTitle: string;
  documentoPopupText: string;

  // Recuperación de documentos
  historicoPopupOpen: boolean;
  historicos: ArchivoHistorico[];
  historicoLoading: boolean;
  historicoCodigo: string;
  historicoActual: ArchivoId;
}

@Styled(s)
export default class BAsignacionComponent extends Component<Props, State> {
  state = {
    downloading: false,
    idCliente: null,
    tipoBusqueda: "",
    filters: {
      page: 0,
      size: 100
    } as any,
    rowPopup: null as DeportivaEventoAsignable,

    // Actualización de empleado
    clasePopupOpen: false,
    clasePopupTitle: "",
    clasePopupText: "",
    programaPopupOpen: false,
    programaPopupTitle: "",
    programaPopupText: "",

    // Configuración de caducidad
    caducidadPopupOpen: false,
    caducidadPopupTitle: "",
    caducidadPopupText: "",

    // Confirmación de acciones en documentos
    archivoPopup: null as Archivo,
    documentoPopupOpen: false,
    documentoPopupTitle: "",
    documentoPopupText: "",

    // Recuperación de documentos
    historicos: [] as ArchivoHistorico[],
    historicoPopupOpen: false,
    historicoLoading: false,
    historicoCodigo: "",
    historicoActual: null as ArchivoId
  };

  componentDidMount(): void {
    this.props.getCmsProductosOperacion();
  }

  onSelectCliente = (persona: Person) => {
    this.setState({
      idCliente: persona.personaId
    });
  };

  onChange = values => {
    this.setState({ tipoBusqueda: values.tipoBusqueda });
  };

  submit = (values: any) => {
    if (this.state.tipoBusqueda === "CLIENTE" && !this.state.idCliente) {
      errorNotification("Seleccione un cliente");
      return;
    }

    // Búsqueda de datos en página 1
    this.fetchData({ page: 0 } as any, null, values);
  };

  // Carga de datos para poblar la tabla
  fetchData = async (
    { pageSize: tablePageSize, page: tablePage },
    _?: any,
    formFilters?
  ) => {
    const filters = formFilters || this.state.filters;
    const page = tablePage >= 0 ? tablePage : this.state.filters.page;
    const size = tablePageSize >= 0 ? tablePageSize : this.state.filters.size;
    const pageableFilters = deleteEmptyProps({
      ...filters,
      idCliente: this.state.idCliente,
      page,
      size
    });

    this.setState({ filters: pageableFilters });

    // Impedir búsquedas vacías
    if (!pageableFilters.tipoBusqueda && !pageableFilters.idProducto) {
      return;
    }

    const preview = await this.props.getCmsClasesAsignables(pageableFilters);
    if (!preview.fulfilled) {
      errorNotification(
        preview.gettingCmsClasesAsignablesError ||
          "Error al obtener las clases o programas deportivos"
      );
    }
  };

  onExport = () => {
    // Implementar si se necesita
    // this.setState({ downloading: true });
  };

  onVerMembresia = (row: DeportivaEventoAsignable) => {
    const idClubBase = row.idClubMembresia;
    const idPublico = row.idPublico;
    window.open(
      `/membresias-socios?idClub=${idClubBase}&idPublico=${idPublico}`,
      "_blank"
    );
  };

  onAsignar = (rowPopup: DeportivaEventoAsignable) => {
    if (rowPopup.esClasePersonalizada) {
      this.setState({
        rowPopup,
        clasePopupOpen: true,
        clasePopupTitle: "Asignar clase",
        clasePopupText: "Seleccione al instructor y la fecha de la clase"
      });
    } else {
      this.setState({
        rowPopup,
        programaPopupOpen: true,
        programaPopupTitle: "Registrar participación",
        programaPopupText: "Seleccione al instructor y el periodo del programa"
      });
    }
  };

  asignar = async (values: any) => {
    const idInstancia = this.state.rowPopup.idProductoInstancia;

    const body = this.state.rowPopup.esClasePersonalizada
      ? {
          idInstancia,
          idPersona: this.state.rowPopup.idPersona,
          idInstructor: values.idInstructor,
          idClubImparticion: this.state.rowPopup.idClubVenta,
          fechaClase: values.fechaClase,
          horaClase: values.horaClase
        }
      : {
          idInstancia,
          idPersona: this.state.rowPopup.idPersona,
          idInstructor: values.idInstructor,
          idClubImparticion: this.state.rowPopup.idClubVenta,
          periodo: values.anio + "-" + values.mes + "-01"
        };

    const preview = await this.props.postCmsAsignacion(
      body,
      this.state.rowPopup.esClasePersonalizada
    );

    if (!preview.fulfilled) {
      errorNotification(
        this.props.postingCmsAsignacionError ||
          "Error al asignar el evento, intente de nuevo por favor"
      );
    } else {
      this.setState({
        clasePopupOpen: false,
        programaPopupOpen: false
      });
      this.fetchData({} as any);
    }
  };

  onRegenerar = async (
    row: DeportivaEventoAsignable,
    archivo: Archivo,
    values?: any
  ): Promise<Preview<any>> => {
    if (values) {
      values = Object.keys(values).reduce((acc, key) => {
        acc[key] =
          values[key] !== null && values[key] !== undefined
            ? String(values[key])
            : values[key];
        return acc;
      }, {});
    }

    const requestArchivo: RequestArchivo = {
      codigo: archivo.codigo,
      idPersonaExpediente: row.idPersona,
      values
    };

    const preview = await this.props.putCmsArchivo(
      row.idProductoInstancia,
      requestArchivo
    );
    if (preview.fulfilled) {
      this.fetchData({} as any);
      successNotification("El documento se ha generado correctamente");
    } else {
      errorNotification(
        "Error al generar el documento, intente de nuevo por favor"
      );
    }
    return preview;
  };

  onCincelFirma = async (row: DeportivaEventoAsignable, archivo: Archivo) => {
    const permRecuperacion = userHasPermission(RECUPERAR_DOCUMENTO);
    const archivoGenerado =
      archivo.statusAutorizacion != StatusAutorizacion.NO_GENERADO;

    // Sin permiso de recuperación de documentos y sin documento generado
    if (!archivoGenerado && !permRecuperacion) {
      errorNotification(
        "Debe generar el documento antes de verificar las firmas"
      );

      return {
        fulfilled: false
      };
    }

    // Comprobar el archivo generado, para no comprobar firmas de no ser necesario
    if (archivoGenerado) {
      const preview = await this.props.putCincelFirmas(
        archivo.idExpediente,
        archivo.idItem
      );

      if (preview.fulfilled) {
        this.fetchData({} as any);
        successNotification("El documento firmado se obtuvo correctamente");

        return preview;
      }
    }

    if (permRecuperacion) {
      this.setState({
        rowPopup: row,
        historicoPopupOpen: true,
        historicos: [],
        historicoLoading: true,
        historicoCodigo: archivo.codigo,
        historicoActual: {
          idExpediente: archivo.idExpediente,
          idItem: archivo.idItem
        }
      });

      // Obtener historial de documentos
      const preview = await this.props.getCmsHistorialDocumentos(
        row.idProductoInstancia,
        archivo.codigo
      );

      if (preview.fulfilled) {
        this.setState({
          historicos: preview.cmsHistorialDocumentos || [],
          historicoLoading: false
        });
      } else {
        this.setState({
          historicoLoading: false
        });
        errorNotification("Error al obtener el historial de documentos");
      }
    }

    return { fulfilled: false };
  };

  onOmitirCaducidad = (rowPopup: DeportivaEventoAsignable) => {
    this.setState({
      rowPopup,
      caducidadPopupOpen: true,
      caducidadPopupTitle: "Configurar validación de caducidad",
      caducidadPopupText:
        "Configure si desea omitir la validación de fecha de caducidad para este evento"
    });
  };

  omitirCaducidad = async (values: any) => {
    const preview = await this.props.putCmsOmitirCaducidad(
      this.state.rowPopup.idProductoInstancia,
      {
        ignorarCaducidad: values.ignorarCaducidad || false,
        razonIgnorarCaducidad: values.razonIgnorarCaducidad || ""
      }
    );

    if (preview.fulfilled) {
      this.setState({ caducidadPopupOpen: false });
      this.fetchData({} as any);
      successNotification(
        this.props.puttingCmsOmitirCaducidadMessage ||
          "Configuración de caducidad actualizada correctamente"
      );
    } else {
      errorNotification(
        this.props.puttingCmsOmitirCaducidadError ||
          "Error al actualizar la configuración de caducidad"
      );
    }
  };

  onCloseArchivoPopup = () => {
    this.setState({
      historicoPopupOpen: false,
      historicos: [],
      historicoCodigo: "",
      historicoActual: null
    });
  };

  onRecuperarArchivo = async (
    row: DeportivaEventoAsignable,
    archivoId: ArchivoId
  ) => {
    this.onCloseArchivoPopup();

    const preview = await this.props.putCmsRecuperarDocumento(
      row.idProductoInstancia,
      this.state.historicoCodigo,
      archivoId.idExpediente,
      archivoId.idItem
    );

    if (preview.fulfilled) {
      this.setState({ historicoPopupOpen: false });
      this.fetchData({} as any);

      successNotification("El documento ha sido recuperado correctamente");
    } else {
      errorNotification(
        preview.puttingCmsRecuperarDocumentoError ||
          "Error al recuperar el documento"
      );
    }
  };

  render() {
    return (
      <Container>
        <FormBuilderModal
          isOpen={this.state.clasePopupOpen}
          title={this.state.clasePopupTitle}
          message={this.state.clasePopupText}
          ok={this.asignar}
          cancel={() => this.setState({ clasePopupOpen: false })}
          formConfig={formConfigClase}
          values={{
            idInstructor: (this.state.rowPopup || {}).idInstructorPrincipal
          }}
          size={"md"}
        />

        <FormBuilderModal
          isOpen={this.state.programaPopupOpen}
          title={this.state.programaPopupTitle}
          message={this.state.programaPopupText}
          ok={this.asignar}
          cancel={() => this.setState({ programaPopupOpen: false })}
          formConfig={formConfigPrograma}
          values={{
            idInstructor: (this.state.rowPopup || {}).idInstructorPrincipal
          }}
          size={"md"}
        />

        <FormBuilderModal
          isOpen={this.state.caducidadPopupOpen}
          title={this.state.caducidadPopupTitle}
          message={this.state.caducidadPopupText}
          ok={this.omitirCaducidad}
          cancel={() => this.setState({ caducidadPopupOpen: false })}
          formConfig={caducidadFormConfig}
          values={{
            ignorarCaducidad:
              (this.state.rowPopup || {}).ignorarCaducidad || false,
            razonIgnorarCaducidad:
              (this.state.rowPopup || {}).razonIgnorarCaducidad || ""
          }}
          size={"md"}
        />

        <FormBuilder<Inputs, Buttons>
          config={formConfig}
          submit={this.submit}
          processing={
            this.props.gettingCmsClasesAsignables ||
            this.props.postingCmsAsignacion ||
            this.props.puttingCmsOmitirCaducidad ||
            this.props.puttingCmsRecuperarDocumento
          }
          onChange={this.onChange}
        >
          {/* Selector de productos */}
          <ITypeSelectBuilder<Inputs>
            name="idProducto"
            data={this.props.cmsProductosOperacion || []}
            mapOption={option => ({
              value: option.idProducto,
              label: option.producto
            })}
            isLoading={this.props.gettingCmsProductosOperacion}
          />

          {/* Selector de clientes */}
          <div
            data-form-name="idCliente"
            className="col-md-6"
            hidden={this.state.tipoBusqueda !== "CLIENTE"}
          >
            <PersonSelector
              label={"* Cliente"}
              setPerson={this.onSelectCliente}
              canEdit={true}
              cKey={"TNYOID6Q5C60"}
            />
          </div>
        </FormBuilder>

        <hr className="row" />

        <MemoTable
          page={
            this.props.cmsClasesAsignables ||
            ({} as Page<DeportivaEventoAsignable>)
          }
          loading={
            this.state.downloading ||
            this.props.gettingCmsClasesAsignables ||
            this.props.archivoRefreshLoading ||
            this.props.cincelFirmasLoading ||
            this.props.puttingCmsRecuperarDocumento
          }
          onFetchData={this.fetchData}
          onExport={this.onExport}
          onAsignar={this.onAsignar}
          onVerMembresia={this.onVerMembresia}
          onRegenerar={this.onRegenerar}
          onCincelFirma={this.onCincelFirma}
          onOmitirCaducidad={this.onOmitirCaducidad}
        />

        {/* Popup de recuperación de documentos */}
        <BAsignacionArchivosPopUp
          row={this.state.rowPopup}
          isOpen={this.state.historicoPopupOpen}
          archivos={this.state.historicos}
          archivo={this.state.historicoActual}
          loading={this.state.historicoLoading}
          onClose={this.onCloseArchivoPopup}
          onRecuperar={this.onRecuperarArchivo}
        />
      </Container>
    );
  }
}
